import { Link, useLocation } from '@tanstack/react-router';
import { GitPullRequest } from 'lucide-react';

import { NavigationUserInfo } from '@/entities/user/components/index';
import { WORKSPACE_PLAN } from '@/entities/workspace/workspace-constants';
import { NewSynclyLogo } from '@/shared/components/new-syncly-logo';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from '@/shared/components/shadcn/sidebar';

export function InternalSidebar() {
  const location = useLocation();
  const { state } = useSidebar();

  const menuItems = [
    {
      title: 'Scraping',
      url: '/scraping',
      icon: GitPullRequest,
    },
  ];

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        {state === 'collapsed' ? (
          <>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton size="lg" asChild>
                  <SidebarTrigger className="size-auto" />
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
            <SidebarMenu>
              <SidebarMenuItem>
                <NewSynclyLogo className="mt-2 size-8" />
              </SidebarMenuItem>
            </SidebarMenu>
          </>
        ) : (
          <div className="flex items-stretch justify-between gap-x-1">
            <SidebarMenu>
              <SidebarMenuItem>
                <div className="flex items-center gap-2 p-2">
                  <NewSynclyLogo className="size-8!" />
                  <div className="grid flex-1 text-left text-sm leading-tight">
                    <span className="truncate font-semibold">Internal</span>
                  </div>
                </div>
              </SidebarMenuItem>
            </SidebarMenu>
            <SidebarTrigger className="size-auto" />
          </div>
        )}
      </SidebarHeader>
      <SidebarContent>
        {menuItems.length > 0 && (
          <SidebarGroup>
            <SidebarGroupContent className="flex flex-col gap-2 py-0.5">
              <SidebarMenu>
                {menuItems.map((item) => {
                  const isActive = location.pathname === item.url;
                  return (
                    <Link to={item.url} key={item.title}>
                      <SidebarMenuItem>
                        <SidebarMenuButton tooltip={item.title} isActive={isActive}>
                          {item.icon && <item.icon />}
                          <span>{item.title}</span>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    </Link>
                  );
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}
      </SidebarContent>
      <SidebarFooter>
        <NavigationUserInfo
          isCollapsed={state === 'collapsed'}
          plan={WORKSPACE_PLAN.ENTERPRISE}
          workspaceId="internal"
        />
      </SidebarFooter>
    </Sidebar>
  );
}
